import TasksSection from './components/tasks-section/tasks-section';
import React, { useEffect, useMemo } from 'react';
import globalCourseStore from '../../../stores/global-course-store';
import { BubbleType } from '../../../component/bubble-text/bouble-text';
import { getAssignmentStatusText } from './operations/get-assignment-status-text';
import { CourseAssignmentStatus } from '../../../api/types/programs/course/assignments/course-assignment-status';
import { observer } from 'mobx-react-lite';
import './exams/expandabe-table-view-icon-rtl.css';
import { CourseExams } from './exams/course-exams';

export interface ProgramCourseAssignmentsAndExamsDatamodel {
  isProfessor: boolean;
}

const ProgramCourseAssignmentsAndExams: React.FC<ProgramCourseAssignmentsAndExamsDatamodel> =
  observer(({ isProfessor }) => {
    const courseAssignmentPageModel = useMemo(() => {
      if (
        !globalCourseStore.currentId ||
        !globalCourseStore.courses.get(globalCourseStore.currentId!)
      ) {
        return [];
      }

      const assignments = globalCourseStore.courses.get(
        globalCourseStore.currentId!,
      )!.details!.assignments;

      return assignments.map((item) => ({
        id: item.id,
        taskName: item.assignmentName,
        dueDate: item.dueDate,
        percent: item.assignmentWeight,
        bubbleText: getAssignmentStatusText(item.status),
        fileUrl: item.fileUrl,
        fileName: item.fileName,
        isGradesPublished: item.isGradesPublished,
        averageGrade: item.averageGrade,
        bubbleCallBack: (index: number) => {
          // TODO
        },
        bubbleType:
          item.status === CourseAssignmentStatus.CLOSE_TO_SUBMIT
            ? BubbleType.RED
            : BubbleType.GREEN,
      }));
    }, [globalCourseStore.version, globalCourseStore.currentId]);

    /*useEffect(() => {
    courseAssignmentPageModel();
  }, [globalCourseStore.version]);*/

    const asd = useMemo(() => {
      // TODO
      return globalCourseStore.courses.get(globalCourseStore.currentId!)!
        .details!.exams;
    }, []);

    return (
      <div>
        <TasksSection
          tasks={courseAssignmentPageModel}
          onTaskSelected={(index) => {
            console.log();
          }}
        />

        <div style={{ marginTop: '20px' }} />
        <CourseExams isProfessor={isProfessor} />
        {/*{examsComponent('מבחנים', asd)}*/}
      </div>
    );
  });

export default ProgramCourseAssignmentsAndExams;
